export default import.meta.ROLLDOWN_FILE_URL_owDZluo8NDg9LkLD337N_w